// The reply must show the address being saved (2026-10-19, prod contact
// 7986822). A person can edit an "update shipping address" step before
// Process, and nothing rewrites the reply from that edit, so the reply box
// warns when an edited address is not what the reply shows. Never rewrites
// the reply.
import { getEditableAddressDefault } from './suggestionActionInputs.js'

export const ADDRESS_REPLY_MISMATCH_WARNING = 'The reply shows a different address than the one being saved.'

// The steps whose address the reply confirms: the address-confirmation update,
// the Sales Hold phone call's update (its reply shows the address on file
// until the agent types the one from the call) and the address validation
// update.
const ADDRESS_STEP_TYPES = new Set(['address_confirmation_update_address', 'sales_hold_phone_call_update_address', 'sales_hold_address_validation_update'])
const FIELDS = ['shippingAddress1', 'shippingAddress2', 'shippingCity', 'shippingRegion', 'shippingPostalCode']

const norm = (v) => String(v ?? '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim().toLowerCase()

// actions: the suggestion's proposed steps; actionInputs: the panel's per-step
// inputs ({ [index]: { editedAddress } }); reply: the reply box's text (HTML
// or plain). Returns the warning, or null.
export function addressReplyMismatchWarning({ actions = [], actionInputs = {}, reply = '' } = {}) {
  const text = norm(reply)
  if (!text) return null
  for (const [i, a] of (actions ?? []).entries()) {
    if (!ADDRESS_STEP_TYPES.has(a?.type)) continue
    const edited = actionInputs?.[i]?.editedAddress
    if (!edited) continue
    const proposed = getEditableAddressDefault(a) ?? {}
    for (const f of FIELDS) {
      const now = norm(edited[f])
      const was = norm(proposed[f])
      if (now === was) continue
      // A changed value the reply doesn't show, or a removed one it still does.
      if (now ? !text.includes(now) : (was && text.includes(was))) return ADDRESS_REPLY_MISMATCH_WARNING
    }
  }
  return null
}
